import React from 'react';
import { StyledModal, FilterHeader, ClearButton, FilterList, FilterItem, CheckedIcon } from './StyledComponents';

const FilterModal = ({
  options, value, defaultValue, onChange, isOpen, onRequestClose, headerTitle, hasHeader,
}) => (
  <StyledModal isOpen={isOpen} onRequestClose={onRequestClose}>
    {hasHeader && (
      <FilterHeader>
        <span>{headerTitle}</span>

        <ClearButton
          onClick={() => {
            onChange(defaultValue);
            onRequestClose();
          }}
        >
        Clear
        </ClearButton>
      </FilterHeader>
    )}

    <FilterList>
      {options.map(option => (
        <FilterItem
          onClick={() => {
            onChange(option.value);
            onRequestClose();
          }}
        >
          {option.label}
          {option.value === value && <CheckedIcon />}
        </FilterItem>
      ))}
    </FilterList>
  </StyledModal>
);

export default FilterModal;

